import React, {FC} from "react"

import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import {OverlayPlacement} from "@irati/ui/src/Tooltip/Overlay"

import {FormatMessage} from "@irati/utils/lang/types"
import {StyledTextArea, StyledFormGroup, StyledIconTooltip} from "./styled"

const MAX_CHAR_LENGTH = 55

interface Props {
  value?: string
  onChange: (value: string) => void
}

const schema = (formatMessage: FormatMessage) =>
  Validation.string(formatMessage({id: "platform.defaultValidation.required"})).max(
    MAX_CHAR_LENGTH,
    formatMessage({id: "platform.defaultValidation.maxLength"}, {count: MAX_CHAR_LENGTH})
  )

const CompanyNewsTitleInput: FC<Props> = ({value, onChange}) => {
  const {formatMessage} = useIntl()

  return (
    <StyledFormGroup>
      <StyledTextArea
        label={
          <>
            <FormattedMessage id="culturehub.companyNews.edit.description.title" />
            <StyledIconTooltip placement={OverlayPlacement.Bottom}>
              <FormattedMessage id="platform.homepage.fields.description.tooltip" />
            </StyledIconTooltip>
          </>
        }
        maxLength={MAX_CHAR_LENGTH}
        placeholder={formatMessage({id: "platform.homepage.fields.description.placeholder"})}
        name="description"
        onChange={onChange}
        rows={1}
        validation={schema(formatMessage)}
        value={value}
      />
    </StyledFormGroup>
  )
}

export default CompanyNewsTitleInput
